<template>
  <div class="container">
    <div class="nav">
      <div class="nav_title">未读列表</div>
      <div class="nav_left_btn" @click="toBack">
        <img :src="cancel" alt width="15" height="25" />
        <span class="back">返回</span>
      </div>
    </div>
    <div class="list">
      <ul
        class="list_content"
        style="margin-top:1rem"
        v-for="item in list"
        :key="item.dptId"
        @click="touserUnreadFn(item)"
      >
        <li class="left">{{item.dptName}}</li>
        <li class="center">
          <span>已读 ({{item.msgReadNum}})</span>
          <span>|</span>
          <span>未读 ({{item.msgUnReadNum}})</span>
        </li>
        <li class="right">&gt;</li>
      </ul>
    </div>
  </div>
</template>

<script>
import { getMsgReadAPI } from "@/api/inform";
import cancel from "@/assets/cancel.png";
export default {
  data() {
    return {
      msgId: "",
      list: [],
      cancel,
    };
  },
  created() {
    this.msgId = this.$route.query.id;
    this.getReadFn();
  },
  methods: {
    toBack() {
      this.$router.go(-1);
    },
    async getReadFn() {
      const res = await getMsgReadAPI(this.msgId);
      if (res.code === 0) {
        this.list = res.data;
      }
    },
    touserUnreadFn(item) {
      this.$router.push({
        path: "inform-userUnread",
        query: {
          msgId: this.msgId,
          item: JSON.stringify(item),
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  height: 100vh;
  & > .nav {
    width: 100%;
    position: fixed;
    top: 0;
    display: block;
    text-align: center;
    height: 48px;
    color: white;
    overflow: hidden;
    border-bottom: 1px solid rgba(181, 201, 210, 0.6);
    background-color: #ffffff;
    z-index: 99;

    & > .nav_title {
      display: block;
      font-size: 1.1rem;
      overflow: hidden;
      white-space: nowrap;
      line-height: 49px;
      text-overflow: ellipsis;
      color: #607483;
      width: 60%;
      margin: 0 auto;
      background-color: #ffffff;
    }

    & > .nav_left_btn {
      float: left;
      position: absolute;
      border-width: 9px 5px 9px 7px;
      border-color: transparent;
      background-size: 12px 1.25rem;
      line-height: 1rem;
      font-size: 1rem;
      color: #607483;
      padding: 0 4px 0 15px;
      top: 9px;
      left: 0;
      min-height: 30px;
      display: flex;
      align-items: center;
    }

    & > .nav_right_btn {
      float: right;
      position: absolute;
      border-width: 9px 4px 9px 3px;
      border-color: transparent;
      background: transparent;
      line-height: 1rem;
      font-size: 1rem;
      color: #607483;
      padding: 0 8px 0 2px;
      top: 8px;
      right: 0;
      min-width: 52px;
      min-height: 30px;
      display: flex;
      align-items: center;
    }
  }
  .list {
    padding-top: 5rem;
    .list_content {
      width: 95%;
      margin: 0 auto;
      display: flex;
      height: 5rem;
      line-height: 5rem;
      background: white;
      border-radius: 0.5rem;
      .left {
        width: 50%;
        text-indent: 1rem;
        color: black;
      }
      .center {
        width: 40%;
      }
      .right {
        width: 10%;
        font-family: "宋体";
        font-weight: 700;
        text-align: center;
      }
    }
  }
}
</style>